export default __webpack_public_path__ + "media/icons/icon-activities-success-green-32dcff14.svg";